'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactNumberFormat = require('react-number-format');

var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);

var _reactCssComponent = require('react-css-component');

var _LineupUsername = require('./LineupUsername');

var _LineupUsername2 = _interopRequireDefault(_LineupUsername);

var _colors = require('../styles/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var css = '\n.display-table {\n  display: table;\n  width: 100%;\n}\n.display-table-row {\n  display: table-row;\n}\n.display-table-cell {\n  display: table-cell;\n  vertical-align: middle;\n  position: relative;\n}\n.display-table-cell-equal-width {\n  max-width: 0;\n  vertical-align: top;\n  padding: 0 !important;\n}\n.lineup-highlight-on {\n  border-left: 5px solid #8DCB90;\n  transition: all 0.2s;\n}\n.time-elapsed-display {\n  height: 3px;\n  border-radius: 4px;\n}\n.time-elapsed-display-gutter {\n  height: 3px;\n  background-color: #eaeaea;\n}\n';
var getBgColor = function getBgColor(te) {
    if (te < 40) {
        return 'success';
    } else if (te < 70) {
        return 'warning';
    } else if (te < 100) {
        return 'danger';
    }
    return 'gray';
};

var LineupCardHeader = function (_PureComponent) {
    _inherits(LineupCardHeader, _PureComponent);

    function LineupCardHeader(props) {
        _classCallCheck(this, LineupCardHeader);

        var _this = _possibleConstructorReturn(this, (LineupCardHeader.__proto__ || Object.getPrototypeOf(LineupCardHeader)).call(this, props));

        _this.state = {
            hover: false
        };
        _this.hoverOn = _this.hoverOn.bind(_this);
        _this.hoverOff = _this.hoverOff.bind(_this);
        return _this;
    }

    _createClass(LineupCardHeader, [{
        key: 'hoverOn',
        value: function hoverOn() {
            this.setState({ hover: true });
        }
    }, {
        key: 'hoverOff',
        value: function hoverOff() {
            this.setState({ hover: false });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var lineupTag = 'No Tag Set';
            if (this.props.lineup.tags && this.props.lineup.tags.length > 0 && this.props.lineup.tags['0'].tag !== null) {
                lineupTag = this.props.lineup.tags['0'].tag;
            }

            var lineupCardHeader = void 0;

            var viewPlayersInLineups = this.props.viewPlayersInLineups;
            var viewPlayersInLineupsFound = false;
            var lineupClasses = ['display-table-cell'];
            var playersFound = 0;
            if (viewPlayersInLineups.length > 0) {
                if (this.props.lineup.lineup_players) {
                    this.props.lineup.lineup_players.map(function (player) {
                        if (player.values !== null && viewPlayersInLineups.includes(player.values.player_id)) {
                            playersFound++;
                        }
                        return playersFound;
                    });
                }
                if (playersFound === viewPlayersInLineups.length) {
                    viewPlayersInLineupsFound = true;
                }
            }

            if (viewPlayersInLineupsFound) {
                lineupClasses.push('lineup-highlight-on');
            }

            var timeLineDisplayWidth = (100 - this.props.lineup.time_elapsed) / 2;

            if (this.props.viewFullLineupCard) {
                lineupCardHeader = _react2.default.createElement(
                    'div',
                    {
                        className: 'display-table-row hover',
                        onClick: function onClick() {
                            return _this2.props.handleLineupClick(_this2.props.lineup);
                        },
                        onMouseEnter: this.hoverOn,
                        onMouseLeave: this.hoverOff
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table-cell', style: { verticalAlign: 'top', width: '40%' } },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'small-text',
                                style: { paddingBottom: '15px', color: colors[this.props.color] }
                            },
                            'PIR: ',
                            this.props.lineup.time_remaining
                        ),
                        this.props.lineup.user_name ? this.props.lineup.place + '. ' + this.props.lineup.user_name : _react2.default.createElement(
                            'span',
                            { className: 'label-outline gray-text' },
                            lineupTag
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'display-table-cell',
                            style: { textAlign: 'right', width: '27%', paddingRight: '8px' }
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'blue-text' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                parseFloat(this.props.lineup.live_proj_points).toFixed(2)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'small-text italic-text blue-text' },
                            'Projected Points'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'display-table-cell',
                            style: { textAlign: 'right', width: '30%', paddingRight: '8px' }
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'green-text' },
                            _react2.default.createElement(
                                'h1',
                                null,
                                parseFloat(this.props.lineup.live_points).toFixed(2)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'small-text italic-text green-text' },
                            'Live Points'
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table-cell', style: { width: '3%', padding: '0' } },
                        _react2.default.createElement('div', {
                            className: this.props.selectedLineup === this.props.lineup.lineup_id || this.state.hover ? 'arrow-right' : ''
                        })
                    )
                );
            } else {
                lineupCardHeader = _react2.default.createElement(
                    'div',
                    {
                        className: 'display-table-row hover',
                        onClick: function onClick() {
                            return _this2.props.handleLineupClick(_this2.props.lineup);
                        },
                        onMouseEnter: this.hoverOn,
                        onMouseLeave: this.hoverOff
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            className: lineupClasses.join(' '),
                            style: { verticalAlign: 'top', width: '6%', padding: '0 3px', textAlign: 'right' }
                        },
                        _react2.default.createElement(
                            'h4',
                            null,
                            this.props.lineup.place ? this.props.lineup.place : this.props.lineupIdx
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table-cell', style: { width: '32%', paddingLeft: '5px' } },
                        _react2.default.createElement(_LineupUsername2.default, { userName: this.props.lineup.user_name, lineupTag: lineupTag })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table-cell center', style: { width: '12%' } },
                        _react2.default.createElement(
                            'div',
                            { className: 'time-elapsed-display-gutter' },
                            _react2.default.createElement('div', {
                                className: 'time-elapsed-display',
                                style: {
                                    width: timeLineDisplayWidth + 'px',
                                    backgroundColor: colors[getBgColor(this.props.lineup.time_elapsed)]
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'display-table-cell',
                            style: { textAlign: 'right', width: '21%', verticalAlign: 'top' }
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'blue-text' },
                            _react2.default.createElement(
                                'span',
                                { style: { marginTop: 0, marginBottom: 0 } },
                                parseFloat(this.props.lineup.live_proj_points).toFixed(2)
                            ),
                            this.props.sortLineups === 'proj_points' ? _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.lineup.prize_amount > 0 ? 'small-text dark-blue-text' : 'small-text gray-text'
                                },
                                _react2.default.createElement(_reactNumberFormat2.default, {
                                    value: this.props.lineup.prize_amount,
                                    displayType: 'text',
                                    thousandSeparator: true,
                                    prefix: '$'
                                })
                            ) : ''
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'display-table-cell',
                            style: { textAlign: 'right', width: '23%', verticalAlign: 'top', paddingRight: '8px' }
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'green-text' },
                            _react2.default.createElement(
                                'span',
                                { style: { marginTop: 0, marginBottom: 0 } },
                                parseFloat(this.props.lineup.live_points).toFixed(2)
                            ),
                            this.props.sortLineups === 'live_points' ? _react2.default.createElement(
                                'div',
                                {
                                    className: this.props.lineup.prize_amount > 0 ? 'small-text dark-green-text' : 'small-text gray-text'
                                },
                                _react2.default.createElement(_reactNumberFormat2.default, {
                                    value: this.props.lineup.prize_amount,
                                    displayType: 'text',
                                    thousandSeparator: true,
                                    prefix: '$'
                                })
                            ) : ''
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'display-table-cell', style: { width: '6%', padding: '0' } },
                        this.props.selectedLineup === this.props.lineup.lineup_id || this.state.hover ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('i', { className: 'far fa-eye blue-text' })
                        ) : null
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'display-table' },
                _react2.default.createElement(_reactCssComponent.UniversalStyle, { css: css }),
                lineupCardHeader
            );
        }
    }]);

    return LineupCardHeader;
}(_react.PureComponent);

exports.default = LineupCardHeader;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/lineups/LineupCardHeader.js
// module id = 802
// module chunks = 0